import { useQuery } from '@tanstack/react-query';
import type { APICommonResponse } from 'src/types/common.types';

import type {
  getCommonCodeRequest,
  getCommonCodeResponse,
} from './common.dto';
import { commonService } from './common.service';

const USE_COMMON_QUERY_KEY = {
  commonCode: 'commonCode',
};

// 공통 코드 조회
interface GetCommonCodeParams {
  groupId: getCommonCodeRequest['group_id'];
}

export const useCommonCodeQuery = ({ groupId }: GetCommonCodeParams) => {
  return useQuery({
    queryKey: [USE_COMMON_QUERY_KEY.commonCode, groupId],
    queryFn: () => commonService.getCommonCode({ group_id: groupId }),
    select: (res: APICommonResponse<getCommonCodeResponse>) => {
      const { data } = res.data;
      return {
        count: data.count,
        rows: data.rows.map((row) => ({
          code: row.dtl_cd,
          name: row.dtl_cd_nm,
        })),
      };
    },
  });
};
